'use client';

import React from 'react';
import styled from '@emotion/styled';
import MobileMenu from './MobileMenu';
import HamburgerToggler from './HamburgerToggler';
import { CSSTransition } from 'react-transition-group';
import { HAMBURGER_MENU_ID, navbp } from '../utils/constants';
const MainMobileNavBase = styled('div')`
  position: relative;

  @media (min-width: ${navbp.extraWideViewport}) {
    display: none;
    flex: 0;
  };
`;
const MobileNav = ({
  onMenuClick,
  menuOpenState,
  children
}) => {
  const nodeRef = React.useRef(null);
  return React.createElement(MainMobileNavBase, null, React.createElement(HamburgerToggler, {
    iconSize: "24",
    onMenuClick: onMenuClick,
    menuOpenState: menuOpenState
  }), React.createElement(CSSTransition, {
    nodeRef: nodeRef,
    mountOnEnter: true,
    unmountOnExit: true,
    in: menuOpenState.isMenuOpen && menuOpenState.menuId === HAMBURGER_MENU_ID,
    timeout: 400
  }, React.createElement(MobileMenu, {
    ref: nodeRef
  }, children)));
};
MobileNav.displayName = 'MobileNav';
export default MobileNav;